import { render, staticRenderFns } from "./allTasks.vue?vue&type=template&id=0889000c&scoped=true&lang=pug"
import script from "./allTasks.vue?vue&type=script&lang=ts"
export * from "./allTasks.vue?vue&type=script&lang=ts"
import style0 from "./allTasks.vue?vue&type=style&index=0&id=0889000c&prod&lang=stylus&scoped=true"
import style1 from "./allTasks.vue?vue&type=style&index=1&id=0889000c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889000c",
  null
  
)

export default component.exports